import React, { useState } from 'react'
import { Button } from '../../components/Buttons';
import { MultiSelect } from '../../components/Forms/FormDefault';
// import { Request } from '../../hooks/Request';
import { toast } from 'react-toastify';
import { useDialog } from '../../contexts/DialogContext';
import PreviewAnnouncement from './PreviousAnnouncement';

const SendAnnouncement = ({ data }) => {
  const { openDialog, dialogClose } = useDialog();
  const [announcement, setAnnouncement] = useState(null);
  const [circularSelected, setCircularSelected] = useState([]);
  const [tipoMercaderias, setTipoMercaderias] = useState([]);
  // const { data: circulars } = Request({
  //   urlApi: `/circular`
  // });
  // const { data: clientes } = Request({
  //   urlApi: `/company`
  // });

  async function onSubmit(values) {
    if (!announcement) {
      toast.error("Debe seleccionar una plantilla");
    }
    if (tipoMercaderias?.tipoMercaderias?.length === 0) {
      toast.error("Debe seleccionar al menos un tipo de cliente");
    }
    else {
      openDialog(
        <PreviewAnnouncement
          values={{ announcementId: announcement.announcement.value, circulars: circularSelected.circular, tipoMercaderias: tipoMercaderias.tipoMercaderias }}
          dialogClose={dialogClose}
        />

      )
      console.log({ announcementId: announcement.announcement.value, circulars: circularSelected.circular, tipoMercaderias: tipoMercaderias.tipoMercaderias })
    }
    // await requestAuth(
    //   values.isUpdate ? "put" : "post",
    //   `/announcement`,
    //   {...values,tipoMercaderias}
    // )
    //   .then(() => {
    //     setReload(x => !x);
    //     toast.success("Registro exitoso");
    //   })
    //   .catch(() => {
    //     toast.error("Se produjo un error al guardar");
    //   });
  }

  return (
    <div className='bg-white p-2 flex flex-col gap-2 rounded-md'>
      <div className='font-semibold text-center'>ENVIAR BOLETÍN INFORMATIVO</div>
      <div>
        <SubTitle text={'NRO DE BOLETIN INFORMATIVO'} />
        <MultiSelect
          url={`/announcement/bySelect`}
          defaultValue={null}
          name={`announcement`}
          valueOption={`id`}
          labelOption={`title`}
          options={null}
          isMulti={false}
          label={`Circulares`}
          setParams={setAnnouncement}
        />
      </div>
      <div>
        <SubTitle text={'NORMATIVAS'} />
        <MultiSelect
          url={`/circular/bySelect`}
          defaultValue={null}
          name={`circular`}
          valueOption={`id`}
          labelOption={`name`}
          options={null}
          label={`Circulares`}
          setParams={setCircularSelected}
        />
        {/* <div className='flex gap-2'>
          {circulars?.map((val, idx) => (
            <div
              className={`flex p-2 rounded-md items-center cursor-pointer gap-2 ${circularSelected.some(f => f.id === val.id) ? 'bg-[#3f649b] text-white' : 'bg-[#3f649b30]'
                }`}
              key={idx}
              onClick={() => {
                setCircularSelected((prevSelected) => {
                  // Verificar si ya está seleccionado
                  const isSelected = prevSelected.some(item => item.id === val.id);

                  if (isSelected) {
                    // Si está seleccionado, lo quitamos
                    return prevSelected.filter(item => item.id !== val.id);
                  } else {
                    // Si no está seleccionado, lo agregamos
                    return [...prevSelected, val];
                  }
                });
              }}
            >
              <i className='far fa-file text-xl' />
              <span className='text-sm'>
                {val.name}
              </span>
            </div>
          ))}
        </div> */}
      </div>
      <div>
        <SubTitle text={'CLIENTES POR TIPO DE MERCADERÍA'} />
        <MultiSelect
          url={`dropdown/tiposMeMercaderia/options`}
          defaultValue={null}
          name={`tipoMercaderias`}
          valueOption={`name`}
          labelOption={`name`}
          options={null}
          label={`Mercadería`}
          setParams={setTipoMercaderias}
        />
        {/* <div className='grid grid-cols-4 gap-2'>
          {clientes?.map((val, idx) => (
            <div
              className={`flex p-2 rounded-md items-center cursor-pointer gap-2 ${clienteSelected.some(f => f.id === val.id) ? 'bg-[#3f649b] text-white' : 'bg-[#3f649b30]'
                }`}
              key={idx}
              onClick={() => {
                setClienteSelected((prevSelected) => {
                  // Verificar si ya está seleccionado
                  const isSelected = prevSelected.some(item => item.id === val.id);

                  if (isSelected) {
                    // Si está seleccionado, lo quitamos
                    return prevSelected.filter(item => item.id !== val.id);
                  } else {
                    // Si no está seleccionado, lo agregamos
                    return [...prevSelected, val];
                  }
                });
              }}
            >
              <span className='text-sm'>
                {val.razonSocial}
              </span>
            </div>
          ))}
        </div> */}
      </div>
      <Button
        className="p-2"
        type="button"
        onClick={() => onSubmit()}
      >
        Verificar
      </Button>
    </div>
  )
}

const SubTitle = ({ text }) => {
  return <h1 className='mb-1 font-semibold pt-1 pl-1 pr-1'>
    {text}
  </h1>
}

export default SendAnnouncement